import React from "react"
import Maliat from "./../../images/icons/organizations/maliat.png";
import Behzisti from "./../../images/icons/organizations/behzisti.png";
import GroupFolderItem from "./../GroupFolderItem"

const organizations = [
  {
    title: 'سازمان امور مالیاتی کشور',
    active: true,
    src: Maliat,
    url: 'https://tao.digimaliat.ir/'
  }, {
    title: 'سازمان بهزیستی کشور',
    active: false,
    src: Behzisti,
    url: 'https://behzisti.digimaliat.ir/'
  }
]

export default () => {
  return (
    <div>
      <h3 className="m-0 text-shadow font-16 pr-16">آزمون های سازمانی</h3>
      <hr className="mb-0" />

      <div className="p-32">
        <div className="grid" style={{
          gridTemplateColumns: 'repeat(2, 1fr)',
          gridGap: 16,
        }}>
          {
            organizations.map((item, index) => (
              <GroupFolderItem key={index} title={item.title} icon={item.src}
                active={item.active}
                onClick={() => window.location.href = item.url} />
            ))
          }
        </div>
      </div>
    </div>
  )
}
